import { METHODS } from "@/constants/apiConstants";
import { apiSlice } from "../baseApi";

const PROFILE_BASE_URL = "/customer-profile";

export const customerProfileApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    updateCustomerProfile: builder.mutation({
      query: ({ id, data }) => ({
        url: `${PROFILE_BASE_URL}/update-customer/${id}`,
        method: METHODS.PUT,
        body: data,
      }),
      // Invalidate tags so queries refetch if needed (optional)
      invalidatesTags: ["CustomerProfile"],
    }),

    updateCustomerImage: builder.mutation({
      query: ({ id, avatarUrl }) => ({
        url: `${PROFILE_BASE_URL}/update-image/${id}`,
        method: METHODS.PUT,
        body: { avatar: avatarUrl },
      }),
      invalidatesTags: ["CustomerProfile"],
    }),
  }),
});

export const {
  useUpdateCustomerProfileMutation,
  useUpdateCustomerImageMutation,
} = customerProfileApiSlice;
